module.exports = {
  "loginVerificationWithHSAuthenticator": {
    "name": "Login Verification with HubSpot Authenticator",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-verification-hs-authenticator-initiated",
        "login-verification-hs-authenticator-succeded",
        "login-verification-hs-authenticator-failed"
      ]
    },
    "namespace": "LoginUi"
  },
  "loginVerificationWithHSAuthResent": {
    "name": "Login Verification with HubSpot Authenticator resent after error",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-verification-hs-authenticator-resent"
      ]
    },
    "namespace": "LoginUi"
  },
  "loginVerificationWithHSAuthCodeOpen": {
    "name": "User clicks `Don't see the prompt`",
    "class": "interaction",
    "properties": {
      "action": "string",
      "type": [
        "login-verification-hs-authenticator-code-open"
      ]
    },
    "namespace": "LoginUi"
  },
  "loginVerificationWithHSAuthCode": {
    "name": "Login Verification with HubSpot Authenticator Code",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-verification-hs-authenticator-code-initiated",
        "login-verification-hs-authenticator-code-succeded"
      ]
    },
    "namespace": "LoginUi"
  },
  "remeberDevice": {
    "name": "Remember this device",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-and-remeber-device"
      ]
    },
    "namespace": "LoginUi"
  },
  "doNotRemeberDevice": {
    "name": "Do not remember this device",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-and-do-not-remeber-device"
      ]
    },
    "namespace": "LoginUi"
  },
  "loginWith2FAHSAuth": {
    "name": "Login with twoFactor",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-with-2fa-HSAuth-succeded",
        "login-with-2fa-HSAuth-failed"
      ]
    },
    "namespace": "LoginUi"
  },
  "smartLoginPageOpened": {
    "name": "Smart Login page opened",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "smartLoginOptOut": {
    "name": "Smart Login Opt-Out",
    "class": "usage",
    "namespace": "LoginUi"
  }
};